export function setDocumentLang(lang) {
  document.documentElement.lang = lang;
}
